import React from "react";
import "../styles/portfolio.css";
import PortfolioNavbar from "./elements/portfolionavbar";
import TestimonialsRow from "./elements/testimonialsrow";
import FaqQuestion from "./elements/faqquestion";
import PortfolioFooter from "./elements/portfoliofooter";
import { useNavigate } from "react-router-dom";
const Logo =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/logo.svg";
const HomeScreen =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/bannerfinal.svg";
const explore1image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/img.svg";
const explore2image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore2.svg";
const explore3image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore3.svg";

const explore4image =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/explore4.svg";
const bottomleftone =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsbottomleft.svg";

const blogIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/blog.svg";
const literatureIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/literature.svg";
const supportIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/support.svg";

const newsIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/news.svg";

const offersIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/offer.svg";
const starIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/star.svg";
const focusIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/focus.svg";

const CustomizeIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/customize.svg";
const heartIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/heart.svg";
export default function Feedback() {
  const navigate = useNavigate();
  return (
    <div className="portfolio">
      <div className="portfoliopadding">
        <div className="portfoliohome">
          <PortfolioNavbar colortheme="blue" />
        </div>
        <div className="portfoliohomebodycontact">
          <button className="portfoliogradientbutton">Feedback</button>
          <h2 className="h2headerportfolio">
            Help Us Improve <br />
            Our Product
          </h2>
          <p>
            Your feedback helps us improve NeuroGen. <br />
            Share your thoughts to make it even better.
          </p>
        </div>
        <div className="portfoliocontactform">
          <form className="gradientdiv portfolioform">
            <div className="portfolioinputdivfull">
              <label>What makes our product great?*</label>
              <textarea required placeholder="Start Typing Here.."></textarea>
            </div>
            <div className="portfolioinputdivfull">
              <label>What would you improve?*</label>
              <textarea required placeholder="Start Typing Here.."></textarea>
            </div>
            <div className="portfolioforminputdiv">
              <div className="portfolioforminputdivhalf">
                <label>First name*</label>
                <input type="text" required />
              </div>
              <div className="portfolioforminputdivhalf">
                <label>Last name*</label>
                <input type="text" required />
              </div>
            </div>
            <div className="portfolioinputdivfull">
              <label>Email*</label>
              <input type="email" required />
            </div>

            <div className="portfoliocheckbox">
              <input type="checkbox" name="agree" />
              <p>I agree to the Privacy & Terms.</p>
            </div>
            <button className="portfoliogradientbutton">Submit</button>
          </form>
        </div>
        <p className="portfoliosubline">
          Looking For Something Else?{" "}
          <a onClick={() => navigate("/contact")}>Contact Us</a>
        </p>
        <PortfolioFooter />
      </div>
    </div>
  );
}
